import { Intl } from 'Roblox';

const intl = Intl && new Intl();

export default function getFormattedFullDate(date: string): string {
  return intl.getDateTimeFormatter().getCustomDateTime(date, {
    month: '2-digit',
    day: '2-digit',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    timeZoneName: 'short'
  });
}
